// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorPrescriptionServiceModelsSignatureModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorPrescriptionServiceModelsSignatureModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorPrescriptionServiceModelsSignatureModel.discriminator = undefined;
EnterpriseCoordinatorPrescriptionServiceModelsSignatureModel.additionalProperties = false;
EnterpriseCoordinatorPrescriptionServiceModelsSignatureModel.attributeTypeMap = [
    {
        "name": "signatureId",
        "baseName": "signatureId",
        "type": "number"
    },
    {
        "name": "isSigned",
        "baseName": "isSigned",
        "type": "boolean"
    },
    {
        "name": "signatureDate",
        "baseName": "signatureDate",
        "type": "Date"
    },
    {
        "name": "dispenseAsWritten",
        "baseName": "dispenseAsWritten",
        "type": "boolean"
    },
    {
        "name": "isSubstitutionAllowed",
        "baseName": "isSubstitutionAllowed",
        "type": "boolean"
    },
];
//# sourceMappingURL=enterpriseCoordinatorPrescriptionServiceModelsSignatureModel.js.map